import {
  calculateColumnWidth,
  mapColumnTypes,
  selectColumnFactory,
  TYPES,
} from "@/react/components/table";
import { getColumnDef } from "@/react/schema/schemaFields";

import schema from "./schema";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(schema.fields.firstName, "First Name"),
        type: TYPES.STRING,
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.lastName, "Last Name"),
        type: TYPES.STRING,
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.email, "Email"),
        type: TYPES.STRING,
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.pbxName, "PBX Name"),
        type: TYPES.STRING,
        editable: true,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
